<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      {{'WALLET_PAGE.WALLET' | translate}}
    </ion-title>
  </ion-toolbar>

  <ion-toolbar style="text-align: center;">
    <ion-segment color="primary" mode="md" [value]="quickfilter" (ionChange)="changequickfilter($event)"  [scrollable]="true">
      <ion-segment-button class="segment-button" value="cards">
        <ion-label>
          {{'WALLET_PAGE.CARDS' | translate}}
          <ion-badge class="voucherBadge" *ngIf="loyaltyCardService.loyaltyCards" color="primary"
            mode="ios">{{loyaltyCardService.loyaltyCards.length}}</ion-badge>
        </ion-label>
      </ion-segment-button>
      <ion-segment-button class="segment-button" value="vouchers">

        <ion-label style="margin: 0;">
          {{'WALLET_PAGE.VOUCHERS' | translate}}
          <ion-badge class="voucherBadge" *ngIf="voucherService.vouchers" color="primary"
            mode="ios">{{voucherService.vouchers.length}}</ion-badge>
        </ion-label>

      </ion-segment-button>
      <ion-segment-button class="segment-button" value="coupons">
        <ion-label style="margin: 0;">
          {{'WALLET_PAGE.COUPONS' | translate}}
          <ion-badge class="voucherBadge" *ngIf="couponService.coupons" color="primary"
            mode="ios">{{couponService.coupons.length}}</ion-badge>
        </ion-label>
      </ion-segment-button>
      <ion-segment-button class="segment-button" value="rewards">
        <ion-label>
          {{'WALLET_PAGE.REWARDS' | translate}}
          <ion-badge class="voucherBadge" *ngIf="takealotVouchersService.takealotVouchers" color="primary"
            mode="ios">{{takealotVouchersService.takealotVouchers.length}}</ion-badge>
        </ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<app-login-banner *ngIf="authService.isAnonUser()">
</app-login-banner>

<app-notifications-banner>
</app-notifications-banner>


<ion-content *ngIf="quickfilter=='cards'">
  <ion-grid>
    <ion-row class="ion-no-padding">
      <ion-col *ngFor="let loyaltyCard of loyaltyCardService.userLoyaltyCards$ | async; last as last"
        class="ion-no-padding" size-xl="8" offset-xl="2" size-lg="8" offset-lg="2" size-md="8" offset-md="2"
        size-sm="12" size-xs="12" [ngClass]="{'bottom-margin':last}">
        <app-wallet-loyalty-card [loyaltyCard]="loyaltyCard"
          [inMemorySpecial]="giveSpecialBasedOnLoyaltyCard(loyaltyCard)"
          (onSpecialFetched)="addToLoyaltyCardSpecials($event)" (onCardInfoEmit)="updateLoyaltyCardMap($event)"
          [scanRange]="scanRange"></app-wallet-loyalty-card>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ng-container *ngIf="loyaltyCardService.loyaltyCards.length == 0">
    <app-empty-cards-wallet-stamp mode="button" class="stamp-button no-shadow"></app-empty-cards-wallet-stamp>
  </ng-container>

</ion-content> 

<ion-content *ngIf="quickfilter=='vouchers'">
  <ion-grid fixed>
    <ion-row>
      <ion-col *ngFor="let displayVoucherObject of groupedVouchers$ | async; last as last" size-xl="8" offset-xl="2"
        size-lg="8" offset-lg="2" size-md="8" offset-md="2" size-sm="12" size-xs="12" [ngClass]="{'bottom-margin':last}">
        <ion-badge style="position: absolute;
        font-size: 1.5rem;
        z-index: 1;" color="primary" mode="ios">{{displayVoucherObject.count}}</ion-badge>
        <app-voucher-card  [voucher]="displayVoucherObject.voucher"
          [inMemorySpecial]="giveSpecialBasedOnVoucher(displayVoucherObject.voucher)" (onSpecialFetched)="addToVoucherSpecials($event)"
          (onCardInfoEmit)="updateVoucherCardMap($event)" [scanRange]="scanRange">
        </app-voucher-card>
      </ion-col>
    </ion-row>
  </ion-grid>


  <ng-container *ngIf="voucherService.vouchers.length == 0">
    <app-empty-vouchers-wallet-stamp mode="button" class="stamp-button no-shadow"></app-empty-vouchers-wallet-stamp>
  </ng-container>

</ion-content>

<ion-content *ngIf="quickfilter=='coupons'">
  <ion-grid fixed>
    <ion-row>
      <ion-col *ngFor="let displayCouponObject of groupedCoupons$ | async; last as last" size-xl="8" offset-xl="2"
        size-lg="8" offset-lg="2" size-md="8" offset-md="2" size-sm="12" size-xs="12" [ngClass]="{'bottom-margin':last}" >
        <ion-badge style="position: absolute;
        font-size: 1.5rem;
        z-index: 1;" color="secondary" mode="ios">{{displayCouponObject.count}}</ion-badge>
        <app-coupon-card [coupon]="displayCouponObject.coupon"
          [inMemoryCouponListing]="giveCouponListingBasedOnUserCoupon(displayCouponObject.coupon)" (onCouponListingFetched)="addToCouponListings($event)"
          (onCardInfoEmit)="updateCouponCardMap($event)" [scanRange]="scanRange">
        </app-coupon-card>
      </ion-col>
    </ion-row>
  </ion-grid>


  <ng-container *ngIf="couponService.coupons.length == 0">
    <app-empty-coupons-wallet-stamp mode="button" class="stamp-button no-shadow"></app-empty-coupons-wallet-stamp>
  </ng-container>

</ion-content>

<ion-content *ngIf="quickfilter=='rewards'">
  <ion-grid fixed>
    <ion-row>
      <ion-col *ngFor="let reward of takealotVouchersService.userTakealotVouchers$| async; last as last" size-xl="8" offset-xl="2"
        size-lg="8" offset-lg="2" size-md="8" offset-md="2" size-sm="12" size-xs="12" [ngClass]="{'bottom-margin':last}" >
        <app-takealot-voucher-card [voucher]="reward">
        </app-takealot-voucher-card>
      </ion-col>
    </ion-row>
  </ion-grid>


  <ng-container *ngIf="takealotVouchersService.takealotVouchers.length == 0">
    <app-empty-rewards-wallet-stamp mode="button" class="stamp-button no-shadow"></app-empty-rewards-wallet-stamp>
  </ng-container>

</ion-content>

<ion-fab vertical="bottom" horizontal="center" slot="fixed">
  <ion-fab-button color="dark" (click)="back()">
    <ion-icon name="close"></ion-icon>
  </ion-fab-button>
</ion-fab>